// Platform promo codes & gift cards on the Billing page: the promo step of a plan change,
// the "Redeem a code" card and the list of redeemed codes
// (docs/payment-module/platform-offers-api-contract.md §5.3–§5.5).
//
// During the trial a promo is scheduled, not attached (§5.0): it starts with the first
// paid invoice, and every sentence that follows a promo says so rather than "applied".
export default {
  fr: {
    "bill.offers.reviewTitle": "Passer au forfait {plan}",
    "bill.offers.giftcardNotHere": "Une carte cadeau s'utilise depuis « Utiliser un code » sur cette page, pas lors d'un changement de forfait.",
    "bill.offers.startsAfterTrial": "Vous êtes en période d'essai : la remise commencera avec votre première facture payée.",
    "bill.offers.cancel": "Annuler",
    "bill.offers.confirmChange": "Confirmer le changement",
    "bill.offers.planUpdatedPromo": "Forfait mis à jour, code promo appliqué.",
    "bill.offers.planUpdatedPromoScheduled": "Forfait mis à jour. Le code promo commencera à la fin de votre essai.",
    "bill.offers.redeemTitle": "Utiliser un code",
    "bill.offers.redeemSub": "Un code promo ou une carte cadeau offerts par Solunary, sur votre abonnement.",
    "bill.offers.redeemSubmit": "Utiliser ce code",
    "bill.offers.promoAfterTrialNote": "Vous êtes en période d'essai : la remise commencera avec votre première facture payée.",
    "bill.offers.promoReplacesNote": "La remise s'applique à vos prochaines factures et remplace toute remise en cours.",
    "bill.offers.giftcardNote": "Tout le solde de la carte devient un crédit, déduit de vos prochaines factures.",
    "bill.offers.redeemed": "Code utilisé.",
    "bill.offers.redeemedPromo": "Code promo appliqué à votre abonnement.",
    "bill.offers.redeemedPromoScheduled": "Code promo enregistré : il commencera à la fin de votre essai.",
    "bill.offers.redeemedGiftcard": "Carte cadeau utilisée : le crédit sera déduit de vos prochaines factures.",
    "bill.offers.redemptionsTitle": "Vos codes",
    "bill.offers.redemptionsEmpty": "Aucun code utilisé pour l'instant.",
  },
  en: {
    "bill.offers.reviewTitle": "Move to the {plan} plan",
    "bill.offers.giftcardNotHere": "A gift card is used from \"Redeem a code\" on this page, not with a plan change.",
    "bill.offers.startsAfterTrial": "You are on your trial: the discount will start with your first paid invoice.",
    "bill.offers.cancel": "Cancel",
    "bill.offers.confirmChange": "Confirm the change",
    "bill.offers.planUpdatedPromo": "Plan updated, promo code applied.",
    "bill.offers.planUpdatedPromoScheduled": "Plan updated. The promo code will start when your trial ends.",
    "bill.offers.redeemTitle": "Redeem a code",
    "bill.offers.redeemSub": "A promo code or gift card from Solunary, for your subscription.",
    "bill.offers.redeemSubmit": "Redeem this code",
    "bill.offers.promoAfterTrialNote": "You are on your trial: the discount will start with your first paid invoice.",
    "bill.offers.promoReplacesNote": "The discount applies to your upcoming invoices and replaces any current discount.",
    "bill.offers.giftcardNote": "The card's whole balance becomes a credit, deducted from your upcoming invoices.",
    "bill.offers.redeemed": "Code redeemed.",
    "bill.offers.redeemedPromo": "Promo code applied to your subscription.",
    "bill.offers.redeemedPromoScheduled": "Promo code saved: it will start when your trial ends.",
    "bill.offers.redeemedGiftcard": "Gift card redeemed: the credit will be deducted from your upcoming invoices.",
    "bill.offers.redemptionsTitle": "Your codes",
    "bill.offers.redemptionsEmpty": "No code redeemed yet.",
  },
  es: {
    "bill.offers.reviewTitle": "Cambiar al plan {plan}",
    "bill.offers.giftcardNotHere": "Una tarjeta regalo se usa desde «Canjear un código» en esta página, no al cambiar de plan.",
    "bill.offers.startsAfterTrial": "Está en su periodo de prueba: el descuento empezará con su primera factura pagada.",
    "bill.offers.cancel": "Cancelar",
    "bill.offers.confirmChange": "Confirmar el cambio",
    "bill.offers.planUpdatedPromo": "Plan actualizado, código promocional aplicado.",
    "bill.offers.planUpdatedPromoScheduled": "Plan actualizado. El código promocional empezará al terminar su prueba.",
    "bill.offers.redeemTitle": "Canjear un código",
    "bill.offers.redeemSub": "Un código promocional o una tarjeta regalo de Solunary, para su suscripción.",
    "bill.offers.redeemSubmit": "Canjear este código",
    "bill.offers.promoAfterTrialNote": "Está en su periodo de prueba: el descuento empezará con su primera factura pagada.",
    "bill.offers.promoReplacesNote": "El descuento se aplica a sus próximas facturas y sustituye a cualquier descuento vigente.",
    "bill.offers.giftcardNote": "Todo el saldo de la tarjeta se convierte en un crédito, descontado de sus próximas facturas.",
    "bill.offers.redeemed": "Código canjeado.",
    "bill.offers.redeemedPromo": "Código promocional aplicado a su suscripción.",
    "bill.offers.redeemedPromoScheduled": "Código promocional guardado: empezará al terminar su prueba.",
    "bill.offers.redeemedGiftcard": "Tarjeta regalo canjeada: el crédito se descontará de sus próximas facturas.",
    "bill.offers.redemptionsTitle": "Sus códigos",
    "bill.offers.redemptionsEmpty": "Todavía no ha canjeado ningún código.",
  },
};
